import {FC, useEffect, useState} from 'react'
import {BaseModal} from '../../BaseModal/BaseModal'
import styles from './indexGrade.module.css'
import {CreateGrade} from './createGrade'
import {EditGrade} from './editGrad'

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
}

type Props = {
  onCloseAction: () => void
  title: string
  grids: GridTypeResponse[]
  setGradeSelected: (grades: {variationId: number; variations: string[]}[]) => void
  gradeSelected: {variationId: number; variations: string[]}[]
}

const IndexGrade: FC<Props> = ({onCloseAction, title, grids, gradeSelected, setGradeSelected}) => {
  const [showCreateGrade, setShowCreateGrade] = useState(false)
  const [showEditGrade, setShowEditGrade] = useState(false)
  const [selectedGrade, setSelectedGrade] = useState<{
    variationId: number
    variations: string[]
  } | null>(null)

  const findNameGrade = (itemSelected: any) => {
    return grids.find((grade) => grade.id === itemSelected.variationId)?.name
  }

  return (
    <BaseModal onCloseAction={onCloseAction} title={title}>
      <div>
        <div
          className='d-flex align-items-center gap-2'
          onClick={() => {
            setShowCreateGrade(true)
          }}
          style={{cursor: 'pointer'}}
        >
          <div className={styles.addButtonCircle}>
            <i className='fas fa-plus'></i>
          </div>
          <h2 className='m-0 fs-6' style={{color: '#009ef7'}}>
            Adicionar Grade
          </h2>
        </div>
        {gradeSelected.length > 0 && (
          <div className={`mt-6 ${styles.gradeSelected}`}>
            {gradeSelected.map((grade) => (
              <div
                key={grade.variationId}
                className={`pb-8 ${styles.gradeSelectedItem}`}
                onClick={() => {
                  setSelectedGrade(grade)
                  setShowEditGrade(true)
                }}
              >
                <div className={styles.gradeSelectedItemContent}>
                  <p className={`m-0 p-0 fs-6 ${styles.titleGradeSelectedItem}`}>
                    {findNameGrade(grade)}
                  </p>
                  <ul className={`m-0 p-0 list-unstyled d-flex pt-2`}>
                    {grade.variations.map((variation) => (
                      <li className={`${styles.gradeVariationItem}`} key={variation}>
                        {variation}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className={`px-2 py-2 ${styles.arrowIcon}`}>
                  <i className='fas fa-chevron-right'></i>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {showCreateGrade && (
        <CreateGrade
          onCloseAction={() => {
            setShowCreateGrade(false)
          }}
          title={'Adicionar Grade'}
          grids={grids}
          gradeSelected={gradeSelected}
          setGradeSelected={setGradeSelected}
        />
      )}
      {showEditGrade && selectedGrade && (
        <EditGrade
          onCloseAction={() => {
            setShowEditGrade(false)
            setSelectedGrade(null)
          }}
          title={'Editar Grade'}
          grids={grids}
          gradeSelected={gradeSelected}
          setGradeSelected={setGradeSelected}
          selectedGrade={selectedGrade}
        />
      )}
    </BaseModal>
  )
}

export {IndexGrade}
